export const LINK_SYSTEM_PRODUCTS_PT_BR = {
	title: "Importar produto",
	subtitle: "Vincule os produtos importados com os dados de produtos da Zig",
	helpText:
		"Você pode agora vincular os itens importados aos produtos que já temos na plataforma, com tudo preenchido.",
	noCategory: "Sem categoria",
	table: {
		systemProduct: "Vinculo de produtos Zig",
	},
	validation: {
		unlinkedCount: {
			one:
				"1 produto ainda não foi vinculado. Por favor, vincule o produto antes de continuar.",
			other:
				"{count} produtos ainda não foram vinculados. Por favor, vincule todos os produtos antes de continuar.",
		},
	},
};

export type linkSystemProductsTranslations = typeof LINK_SYSTEM_PRODUCTS_PT_BR;
